import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { EditMapHistoryServiceService } from '../edit-map-history-service.service';
import { TranslateService } from '@ngx-translate/core';
import { FeatureCollection, Polygon } from '@turf/turf';
import mapboxgl from 'mapbox-gl';
import { UserFeedbackService } from 'src/app/shared/user-feedback.service';
import { PoiMapEditorData } from 'src/app/shared/model/form';
import { PoiService } from 'src/app/shared/poi.service';
import { firstValueFrom, skipWhile, take } from 'rxjs';
import MapboxDraw from '@mapbox/mapbox-gl-draw';
import { DefaultIconSelect, DefaultIconsPoiMapping, DefaultSpeciesIcons, NetworkConstants, PointOfInterest, createIconImage, deepCopy } from 'diwimamodelweb/lib';
import { SettingsService } from 'src/app/shared/settings.service';
import { ContextAccess, isGeoLocked, resolveContextAccess } from 'src/app/shared/context-rights-picker/context-access';
import * as turf from '@turf/turf'
import { FormBuilder, FormGroup } from '@angular/forms';
import { GeoPoint } from 'firebase/firestore';
import { GenericDialogComponent } from 'src/app/shared/generic-dialog/generic-dialog.component';

@Component({
  selector: 'app-edit-poi-point',
  templateUrl: './edit-poi-point.component.html',
  styleUrl: './edit-poi-point.component.css'
})

export class EditPoiPointComponent {
  map: mapboxgl.Map
  _browserLanguage = navigator.language
  draw: any
  mapStyleOutdors = environment.mapBoxStyleStreets
  mapStyleSatellite = environment.mapBoxStyleOutdoors
  actualFeatures:any
  private preEditionChanges: FeatureCollection<Polygon> | GeoJSON.FeatureCollection<GeoJSON.MultiLineString> | GeoJSON.FeatureCollection<GeoJSON.Point> | null = null;
  showUndoRedo = false
  selectedPOI:any
  oldPOI:any
  zoomHeight = 13.5
  dropdownSettingGeoObjectType: any[]
  selectedPOI_locationCoordinates:any
  poiMapForm!:FormGroup
  @Input() data?: PoiMapEditorData
  @Output() saveMapEditorChanges: EventEmitter<PoiMapEditorData> = new EventEmitter()
  marker: mapboxgl.Marker
  lineMarkers: mapboxgl.Marker[] = []
  contextAccess: ContextAccess = 'owner'

  get isGeoLocked(): boolean { return isGeoLocked(this.contextAccess) }

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private userFeedbackService: UserFeedbackService,
    private translateService: TranslateService,
    private poiService: PoiService,
    private settingsService: SettingsService,
    private editMapHistory: EditMapHistoryServiceService,
    private router: Router
  ) {
    Object.getOwnPropertyDescriptor(mapboxgl, "accessToken").set(environment.mapBoxToken)
  }

   async ngOnInit() {

    this.poiMapForm = this.fb.group({
      lat: [],
      lng:[],
      locationCoordinates: [],
      lineFeature:[],
      polygonFeature:[],
      features:[]
    })

    // this.poiMapForm.get('features').valueChanges.subscribe( value => {
    //   console.log('features',value)
    // })

    this.poiMapForm.get('locationCoordinates').valueChanges.subscribe( value => {
      const copy = deepCopy(this.selectedPOI)
      copy.locationCoordinates = value
      const newpoi = new PointOfInterest()
      newpoi.setFromAny(copy)
      const icon = this.dropdownSettingGeoObjectType?.find( type => type.identifier?.toLowerCase() == newpoi.type?.toLowerCase())?.iconName
      const feature = newpoi.getFeature('',icon )

      const collection: GeoJSON.FeatureCollection<GeoJSON.Point> = {
        features:[feature],
        type: "FeatureCollection"
      }
      this.preEditionChanges = collection//feature//value;

      this.editMapHistory.pushState(this.preEditionChanges);
      this.showUndoRedo = true;
    })

    this.poiMapForm.get('lineFeature').valueChanges.subscribe( value => {

      const collection: GeoJSON.FeatureCollection<GeoJSON.MultiLineString> = {
        features:[value],
        type: "FeatureCollection"
      }
      this.preEditionChanges = collection//feature//value;

      this.editMapHistory.pushState(this.preEditionChanges);
      this.showUndoRedo = true;
    })

    this.poiMapForm.get('polygonFeature').valueChanges.subscribe( value => {

      const collection: GeoJSON.FeatureCollection<GeoJSON.Polygon> = {
        features:[value],
        type: "FeatureCollection"
      }
      this.preEditionChanges = collection//feature//value;

      this.editMapHistory.pushState(this.preEditionChanges);
      this.showUndoRedo = true;
    })

    // this.editMapHistory.undoList.subscribe( value => {
    //   console.log('undos', value)
    // })

    const pois = await firstValueFrom(this.poiService.poiSubject$.pipe( skipWhile(el => !el), take(1) ))

    const poiId = this.route.snapshot.paramMap.get('identifier')
    const poi = pois?.find(el => el.identifier == poiId)
    this.selectedPOI = poi
    const copy = deepCopy(poi)
    this.oldPOI = new PointOfInterest()
    this.oldPOI.setFromAny(poi)

    this.loadMapCoordinates(poi)

    this.poiService.poiSubject$.subscribe( value => {
      const poiId = this.route.snapshot.paramMap.get('identifier')
      const poi = value?.find(el => el.identifier == poiId)
      this.selectedPOI = poi
      // this.loadMapCoordinates(poi )
    })

  }

  async loadMapCoordinates(poi){
    let center: mapboxgl.LngLat|undefined = undefined
    if (poi.locationCoordinates)
      center = new mapboxgl.LngLat(poi?.locationCoordinates?.longitude, poi?.locationCoordinates?.latitude);

    const context = await firstValueFrom(this.settingsService.selectedUserContext$.pipe( skipWhile(el => !el), take(1) ))
    const settingsMap = context.settingsMap
    const subIds = this.settingsService.getSubcontextIds()

    this.contextAccess = resolveContextAccess(
      poi as any,
      context?.identifier,
      subIds//(context as any)?.subContextIds,
    )
    if (this.isGeoLocked) {
      this.userFeedbackService.showSnackBar.emit(
        'Freigegebenes Objekt – die Geometrie kann nur im Ursprungskontext geändert werden.',
      )
    }

    switch(this.selectedPOI.contentType?.toLowerCase()){
      case 'point':{
        this.dropdownSettingGeoObjectType = settingsMap.get(NetworkConstants.SETTING_GEO_TYPE).values
        break;
      }

      case 'line':{
        this.dropdownSettingGeoObjectType = settingsMap.get(NetworkConstants.SETTING_GEO_LINE_TYPES).values
        break;
      }

      case 'polygon': {
        this.dropdownSettingGeoObjectType = settingsMap.get(NetworkConstants.SETTING_GEO_POLYGON_TYPES).values
        break;
      }

      default:{
        this.dropdownSettingGeoObjectType = settingsMap.get(NetworkConstants.SETTING_GEO_TYPE).values
        break;
      }
    }
    this.createMap(poi, center)
  }

  ngOnDestroy(){
    //console.log('--destroy map--')
    this.editMapHistory.reset()
  }

  private async _onMapLoad(poi, draw) {
    this.map.resize()
    let type = undefined
    // if(poi){
      const icon = this.dropdownSettingGeoObjectType?.find( type => type.identifier?.toLowerCase() == this.selectedPOI.type?.toLowerCase())?.iconName

      if(this.selectedPOI.encodedContent){
        let features = this.selectedPOI.getFeatures()
        if (features.length == 0) {
          const txtNoFeatures = await this.translateService.get('snack_msg_no_features').toPromise()
          this.userFeedbackService.showSnackBar.emit(txtNoFeatures)
        }

        features?.forEach((f) => {
          // draw.add(f)
          type = f.geometry.type
          if(f.geometry.type == "MultiLineString"){
            // draw.changeMode('direct_select', { featureId: f.id });
            const coordinates = f.geometry.coordinates[0]
            coordinates.forEach((coord, index) => {
              const [longitude, latitude] = coord
              const div = document.createElement('div');
              div.className = 'marker-diwima';
              div.style.backgroundColor = '#ffb300'
              div.style.borderRadius = '25px'
              div.style.padding = '5px'

              const marker = new mapboxgl.Marker({ element: div, draggable: !this.isGeoLocked })
              .setLngLat([longitude, latitude])
              .addTo(this.map);
            
              this.lineMarkers.push(marker)
            
              // this.lineMarkers[index].on('dragend', () => {
              marker.on('dragend', () => {
                const lngLat = marker.getLngLat();
                const old = deepCopy(coordinates[index])

                coordinates[index] = [lngLat.lng, lngLat.lat];
            
                const collection: GeoJSON.FeatureCollection<GeoJSON.MultiLineString> = {
                  features:[f],
                  type: "FeatureCollection"
                }
                this.lineMarkers[index].setLngLat(coordinates[index]).addTo(this.map);
                const source = this.map.getSource(poi.identifier) as mapboxgl.GeoJSONSource;
                source.setData(JSON.parse(JSON.stringify(collection)));

                this.poiMapForm.patchValue({lineFeature: f, features: [f]})

                this.cleanLineLayer()
              });

            });
          }

          if(f.geometry.type == "MultiPolygon"){
            if(this.isGeoLocked){
              this.showReadOnlyGeometry(f)
            } else {
              draw.add(f)
              draw.changeMode('direct_select', { featureId: f.id });
            }
          }
        })
        this.actualFeatures = features
        const collection: GeoJSON.FeatureCollection<GeoJSON.MultiLineString> = {
          features:[],
          type: "FeatureCollection"
        }

        if(type === "MultiLineString"){
          collection.features = features
          this.editMapHistory.start(collection)
        }

        if(type === "MultiPolygon"){
          collection.features = features
          this.editMapHistory.start(this.draw.getAll())
        }

        this.flyToBoundsGeoObject(this.selectedPOI,  features)
  
        // if(this.selectedPOI.contentType)
        //   this.createGeoObjectPolygonLine(this.selectedPOI, features)
        this.addMapSourcePolygonLine(this.selectedPOI, features, type)
      } else { 
        let feature = this.selectedPOI.getFeature("",icon)
        this.addMapSource('gr-source', feature, icon)
      }
    // }
    

    DefaultSpeciesIcons.forEach(async (iconName: string) =>{
      var canvas = document.getElementById(iconName) as HTMLCanvasElement
      if (canvas) {
        const imageData = await createIconImage(canvas, iconName)
        if (imageData)
          this.map.addImage(iconName, imageData) 
      }
    })

    DefaultIconSelect.forEach(async (value, key) => {
      var canvas = document.getElementById(value) as HTMLCanvasElement
      if (canvas) {
        const imageData = await createIconImage(canvas, value)
        if (imageData)
          this.map.addImage(value, imageData)  
      }
    })
  }

  private createMap(poi?: any, center?:any) {
    //console.log('--createMap--')
    this.map = new mapboxgl.Map({
      container: 'map',
      style: `${this.mapStyleOutdors}`,
      zoom: this.zoomHeight, 
      center: center ? center : [10.369743, 51.081317],
      interactive: true
      // displayControls: false
    })
    this.draw = new MapboxDraw({
      displayControlsDefault: false,
      controls: {
        // polygon: true, //enable this to create new polygons
        // trash: true,
        // line_string: true,//enable this to create new lines
      },

    })
    this.map.addControl(this.draw)

    this.map.on('draw.create', (e: any) => {});

    this.map.on('draw.delete', async (e: any) => {});

    this.map.on('draw.update', (e: any) => {
      const action = e.action;
      const mode = this.draw.getMode();
      const features = e.features;

      if(this.selectedPOI.contentType == 'polygon' || features[0]?.geometry.type === "MultiPolygon"){

        // If user drags polygon (not vertex-edit)
        if (action === 'move') {
          features.forEach(f => this.draw.delete(f.id)); // remove moved version and keep previous
          this.actualFeatures?.forEach((f) => { this.draw.add(f) })
        }
        //If user is on vertex edit
        if( action === 'change_coordinates')
          this.actualFeatures = features
      
        this.poiMapForm.patchValue({ polygonFeature: features[0] })
        this.poiMapForm.patchValue({ features:features })
      }
    });

    this.map.on('load', () => {
      //console.log('--load--')
      this.updateDrawLayerStyles()
      this._onMapLoad(poi, this.draw)
    })

    this.map.on('draw.modechange', (e: any) => {
      if (!this.preEditionChanges) return;
      this.preEditionChanges = null;
    });

  }


  get defaultSpeciesIcons() {
    return DefaultSpeciesIcons
  }

  get defaultPoiIcons() {
    return [...DefaultIconsPoiMapping.values()]
  }
  
  updateDrawLayerStyles() {
    this.map.setPaintProperty('gl-draw-polygon-fill.hot', 'fill-opacity', 0.6)
    this.map.setPaintProperty('gl-draw-polygon-fill.cold', 'fill-opacity', 0.6)
  }

  private async addMapSource(sourceId: string, features: any, icon?:any) {
    const [longitude, latitude] = features.geometry.coordinates

    let iconFile = DefaultIconsPoiMapping.get(icon);
    if (!iconFile)
    iconFile = DefaultIconsPoiMapping.get('pin');
    
    const src =`assets/icons/${iconFile}.svg`
    const div = document.createElement('div');
    const img = document.createElement('img');
    div.className = 'marker-diwima';

    img.src = src;   // your image path
    img.style.width = '30px';
    img.style.height = '30px';
    img.style.cursor = 'grab';
    div.appendChild(img)
    div.style.backgroundColor = '#ffb300'
    div.style.borderRadius = '25px'
    div.style.padding = '5px'

    this.marker = new mapboxgl.Marker({ element: div, draggable: !this.isGeoLocked })
      .setLngLat([longitude, latitude])
      .addTo(this.map);

    this.selectedPOI_locationCoordinates = new GeoPoint(latitude,longitude)

    const collection: GeoJSON.FeatureCollection<GeoJSON.Point> = {
      features:[features],
      type: "FeatureCollection"
    }

    this.editMapHistory.start(structuredClone(collection))

    this.marker.on('dragend', () => {
      const { lng, lat } = this.marker.getLngLat();
      this.poiMapForm.patchValue({lat, lng})
      this.poiMapForm.patchValue({locationCoordinates: new GeoPoint(lat,lng)})
    });
  }

  // TODO: Check and remove if sufficient
  private showReadOnlyGeometry(feature: any): void {
    const sourceId = 'poi-geometry-readonly'
    if (!feature || this.map.getSource(sourceId)) return

    this.map.addSource(sourceId, {
      type: 'geojson',
      data: { type: 'FeatureCollection', features: [feature] } as any,
    })
    this.map.addLayer({
      id: `${sourceId}-fill`,
      type: 'fill',
      source: sourceId,
      paint: { 'fill-color': '#F29100', 'fill-opacity': 0.4 },
    })
    this.map.addLayer({
      id: `${sourceId}-line`,
      type: 'line',
      source: sourceId,
      paint: { 'line-color': '#F29100', 'line-width': 2 },
    })
  }

  private addMapSourcePolygonLine(poi, features, type){
    const source = this.map.getSource(poi.identifier) as mapboxgl.GeoJSONSource
    if (source == null) {
      const geojson = this.selectedPOI.getGeoJsonFromFeatures(features)
      this.map.addSource(poi.identifier, geojson)

      if(type === "MultiLineString")
      this.cleanLineLayer()
    }
  }

  private createGeoObjectPolygonLine(poi: PointOfInterest, features) {
    var layers = this.map.getStyle().layers;
    // Find the index of the first symbol layer in the map style
    var firstSymbolId;
    for (var i = 0; i < layers.length; i++) {
      if (layers[i].type === 'line') {
        firstSymbolId = layers[i].id;
        break;
      }
    }
    const source = this.map.getSource(poi.identifier) as mapboxgl.GeoJSONSource
    if (source == null) {
      const geojson = this.selectedPOI.getGeoJsonFromFeatures(features)
      this.map.addSource(poi.identifier, geojson)

      // if(this.selectedPOI?.contentType?.toLowerCase()== 'polygon'){
      //   this.map.addLayer({
      //     'id': poi.identifier,
      //     'type': 'fill',
      //     'source': poi.identifier,
      //     'layout': {},
      //     'paint': {
      //       'fill-color': '#FFB300',
      //       'fill-opacity': 0.6
      //     }
      //   }, firstSymbolId)
      //   this.map.moveLayer(poi.identifier);
      // }

      // if(this.selectedPOI?.contentType?.toLowerCase()== 'line'){
      //   this.map.addLayer({
      //     id: poi.identifier,
      //     type: 'line',
      //     source: poi.identifier,
      //     paint: {
      //       'line-color': '#FFB300',
      //       'line-width': 4
      //     }
      //   });
      //   this.map.moveLayer(poi.identifier);
      // }
    }
  }

  private flyToBoundsGeoObject(poi: PointOfInterest, features:any[]) {
    if (features.length > 0) {
      const featureCollection = turf.featureCollection(features)
      const boundingBox = turf.bbox(featureCollection)
      const mapbbox = new mapboxgl.LngLatBounds([boundingBox[0], boundingBox[1]], [boundingBox[2], boundingBox[3]])
      // mapbbox.extend() maybe for fitting multiple bboxes...
      this.map.fitBounds(mapbbox, {padding: 15, duration:0})     
    }
  }

  undoActive(){ return this.editMapHistory.checkUndo }
  redoActive(){ return this.editMapHistory.checkRedo }

  clickUndo(){
    if (this.isGeoLocked) return
    const snapshot = this.editMapHistory.undo();
    if (!snapshot || !snapshot.features) return;

    const dataToAdd = deepCopy(snapshot)
    
    if(this.selectedPOI.encodedContent){

      if(dataToAdd.features[0]?.geometry.type == "MultiLineString")
        this.updateMarkersLine(dataToAdd)
      else
        this.updatePolygon(dataToAdd)

    } else
      this.updateMarkerPoint(snapshot)

  }
  
  clickRedo(){
    if (this.isGeoLocked) return
    const snapshot = this.editMapHistory.redo();
    if (!snapshot || !snapshot.features) return;

    const dataToAdd = deepCopy(snapshot)

    if(this.selectedPOI.encodedContent){
      if(dataToAdd.features[0]?.geometry.type == "MultiLineString")
        this.updateMarkersLine(dataToAdd)
      else
        this.updatePolygon(dataToAdd)
      
    } else
      this.updateMarkerPoint(snapshot)
  }

  cleanLineLayer(){
    if(!this.map.getLayer(this.selectedPOI.identifier)){
      //console.log('--cleanLineLayer--')
      this.map.addLayer({
        id: this.selectedPOI.identifier,
        type: 'line',
        source: this.selectedPOI.identifier,
        paint: { 'line-color': '#FFB300', 'line-width': 4 }
      });
      this.map.moveLayer(this.selectedPOI.identifier);
    }
  }

  updateMarkersLine(dataToAdd){
    const source = this.map.getSource(this.selectedPOI.identifier) as mapboxgl.GeoJSONSource;
    const features = dataToAdd.features
    const feature = dataToAdd.features[0]
    source.setData(JSON.parse(JSON.stringify(dataToAdd)))

    const coordinates = feature?.geometry?.coordinates[0]
    coordinates.forEach( (coord, index) => { this.lineMarkers[index].setLngLat(coord).addTo(this.map); })
    this.poiMapForm.patchValue({ features })
  }

  updatePolygon(dataToAdd){
    this.draw.getAll()
    this.draw.deleteAll()
    dataToAdd.features.forEach(f => { this.draw.add(f); this.draw.changeMode('direct_select', { featureId: f.id }); });
    this.poiMapForm.patchValue({ features: dataToAdd.features })
  }

  updateMarkerPoint(snapshot){
    const feature = snapshot?.features[0];
    const [longitude, latitude] = feature.geometry.coordinates as [number, number];
    this.marker.setLngLat([longitude, latitude])
    this.poiMapForm.patchValue({lat:latitude, lng: longitude})
  }

  async onSave(){
    if(this.isGeoLocked){
      this.userFeedbackService.showSnackBar.emit('Geodaten können nicht geändert werden.')
      return
    }

    if(this.selectedPOI.encodedContent){

      const features = this.poiMapForm.get('features').value
      const feature = features[0] ?? {}
      const coordinates = feature?.geometry?.coordinates ?? []
      const type = feature?.geometry?.type

      const encodedContent = this.transformCoordinatesToEncodedContent(feature)//?.join(' ');
      this.selectedPOI.encodedContent = encodedContent

      await this.callUpdatePoiCoordinates(this.oldPOI,this.selectedPOI)
      setTimeout(() => {
        this.successAndNavBack()
      }, 200);
    }else{

      const { locationCoordinates } = this.poiMapForm.value
      this.selectedPOI.locationCoordinates = locationCoordinates
      await this.callUpdatePoiCoordinates(this.oldPOI,this.selectedPOI)
      setTimeout(() => {
        this.successAndNavBack()
      }, 200);
    }
  }

  successAndNavBack(){
    const message = this.translateService.instant("changes_saved")
    this.userFeedbackService.showSnackBar.emit(message)
    this.router.navigate(['..'], {relativeTo: this.route})
  }

  transformCoordinatesToEncodedContent(feature: any): string {
    const point: string[] = [];

    function recurse(coords: any[]) {
      if (typeof coords[0] === 'number')
        point.push(`${coords[1]} ${coords[0]}`); // lat lng
      else
        coords.forEach(c => recurse(c));
    }

    recurse(feature.geometry?.coordinates);
    return point.join(' ');
  }

  async callUpdatePoiCoordinates(oldPoi:PointOfInterest, newPoi){
    try {
      this.userFeedbackService.loading.emit(true)
      const sbSuccessSave = await this.translateService.instant('changes_saved') 
      await this.poiService.updatePointOfInterest(oldPoi, newPoi)
      this.userFeedbackService.loading.emit(false)
      this.userFeedbackService.showSnackBar.emit(sbSuccessSave)
    } catch (error) {
      console.error(error)
      this.userFeedbackService.loading.emit(false)
      this.userFeedbackService.showDialog.emit({
        entryComponent: GenericDialogComponent,
        title: "Error",
        message: error?.error?.message ? error?.error?.message : JSON.stringify(error),
      })
    }
  }
}
